export const addDotsToName = (name, nameSize) => {
  if (!name) return;
  const slicedName = name.slice(0, nameSize);
  return name.length > nameSize ? `${slicedName}...` : name;
};
